import PropTypes from 'prop-types';
import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import cx from 'classnames';
import Button from '../Button';
import { dismissAction } from '../../redux/alert';
import SuccessIcon from '../Icons/Complete';
import Modal from '../Modal';
import styles from './Alert.css';

export const AlertBase = withRouter(({ alert, history, dismiss }) => {
    if (!alert) {
        return null;
    }

    let button = (<Button onClick={() => dismiss()} style={{ fontSize: '14px' }}>
        {alert.button || 'Close'}
    </Button>);

    if (alert.link) {
        button = (<Link to={alert.link}>
            {button}
        </Link>);
    }

    return (<Modal
        onClose={(event) => {
            dismiss();
            if (event.key === 'Enter' && alert.link) {
                history.push(alert.link);
            }
        }}
        className={cx(styles.alert, {
            [styles.prompt]: alert.type === 'prompt',
        })}
        open={!!alert}
    >
        { alert.build && (<img
            src="/img/icon_building.png"
            alt="App colors"
            style={{
                width: 95,
                height: 95,
                marginBottom: 10,
            }}
        />)}
        {alert.type === 'success' && !alert.build ? <SuccessIcon size={75} /> : null}
        {alert.title && <h3>{alert.title}</h3>}
        {alert.message && <p>{alert.message}</p>}
        {button}
    </Modal>);
});

AlertBase.propTypes = {
    dismiss: PropTypes.func,
    alert: PropTypes.object,
    history: PropTypes.object,
};

AlertBase.defaultProps = {
    dismiss: () => null,
};

export default connect(({ alert }) => ({
    alert,
}), {
    dismiss: dismissAction,
})(AlertBase);



// WEBPACK FOOTER //
// ./src/client/Components/Alert/Alert.js